import { useMatch } from "@tanstack/react-router";

export function useIsTemplate() {
  const match = useMatch({
    from: "/_auth/_app-shell/requests/template",
    shouldThrow: false,
  });

  const requestType = match?.search["request-type"];

  return { isTemplate: !!match, requestType };
}
